'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
export default Record({
  contentId: null,
  descriptions: ImmutableMap(),
  id: null,
  image: null,
  name: null,
  twitterUrl: null,
  linkedinUrl: null,
  jobTitle: null,
  organisation: null,
  organisationUrl: null
}, 'Professor');